module.exports = __webpack_public_path__ + "img/public/siteImages/playStore.svg?2220228c";